<template>
  <div class="modelAgreement">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="90"
        :model="formInline"
        inline
      >
        <el-form-item prop="contractName" label="协议名称">
          <el-input
            clearable
            v-model.trim="formInline.contractName"
            placeholder="请输入协议名称"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title">
        <el-button
          size="small"
          type="primary"
          @click="openHandleAgreement('add')"
          >添加</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="协议模板名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contractName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="模板地址" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.templateUrl || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.remarks || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后操作人" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="180" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openHandleAgreement('alter', row)"
              >编辑</span
            >
            <span class="blue_Box" @click="handleDelete(row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 添加、编辑教务服务方 -->
    <HandleAgreement ref="handleAgreementRef" />
  </div>
</template>

<script>
import {
  getContractTemplateListPage,
  delContractTemplate,
} from "@/api/class/modelAgreement.js";
import HandleAgreement from "./components/handleAgreement";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "ModelAgreement",
  components: {
    myPagination,
    HandleAgreement,
  },
  data() {
    return {
      loading: false,
      formInline: {
        contractName: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  mounted() {
    this.getContractTemplateListPage({ page: 1, limit: 10 });
  },
  methods: {
    // 刷新
    refresh() {
      this.getContractTemplateListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该协议模板吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delContractTemplate({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    async getContractTemplateListPage(payload) {
      this.loading = false;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getContractTemplateListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 添加、编辑
    openHandleAgreement(status, payload) {
      this.$refs.handleAgreementRef.init(status, payload);
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getContractTemplateListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getContractTemplateListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getContractTemplateListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getContractTemplateListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.modelAgreement {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
